import { MatrixReportResponseRaw } from '~src/interfaces/heatmap.interface';
import { Question } from '~src/interfaces/question.interface';
import { Topic } from '~src/interfaces/topic.interface';
import { Survey } from '~src/modules/surveys/interfaces';
import { AnalysisLineRequest, RecommendationsRequest } from '~src/services/api/reporting';
import { defaultReportingApi } from '~src/services/ApiController';
import { AsyncAction } from '~src/services/apiMiddleware';
import { fetchQuestionsMatrix, fetchRecommendationsTypes, fetchTopicsMatrix } from '~src/store/heatmap/action.types';

export enum AnalysisActionKeys {
  analysisSurveyTopics = 'analysisSurveyTopics',
  analysisTopicQuestions = 'analysisTopicQuestions',
}

export interface SurveyTopicsAction {
  type: AnalysisActionKeys.analysisSurveyTopics;
  survey: Survey;
  topics: Topic[];
}

export interface TopicQuestionsAction {
  type: AnalysisActionKeys.analysisTopicQuestions;
  topic: Topic;
  questions: Question[];
}

export type ChartDimensionsAction = SurveyTopicsAction | TopicQuestionsAction;

export const fetchLines = (requestedLines: AnalysisLineRequest[]): AsyncAction<MatrixReportResponseRaw, undefined> => {
  return {
    types: requestedLines[0] && requestedLines[0].topicId ? fetchQuestionsMatrix : fetchTopicsMatrix,
    callAPI: () => defaultReportingApi.fetchLines(requestedLines),
  };
};

export const chartDimensionSurveyTopicsAction = (survey: Survey, topics: Topic[]): SurveyTopicsAction => ({
  type: AnalysisActionKeys.analysisSurveyTopics,
  survey,
  topics,
});

export const chartDimensionTopicQuestionsAction = (topic: Topic): TopicQuestionsAction => ({
  type: AnalysisActionKeys.analysisTopicQuestions,
  topic,
  questions: topic.questions || [],
});

export const fetchRecommendationsAction = (
  args: RecommendationsRequest[],
): AsyncAction<MatrixReportResponseRaw, undefined> => {
  return {
    types: fetchRecommendationsTypes,
    callAPI: () => defaultReportingApi.fetchRecommendations(args),
  };
};
